import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService, AuthService } from '@wm-libs/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { map, Subject, takeUntil } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-after-signup',
  templateUrl: './after-signup.component.html',
  styleUrls: ['../../styles/auth.scss'],
  standalone: true,
  imports: [NgClass, MatCardModule, MatButtonModule, AsyncPipe, TranslateModule],
})
export class AfterSignupComponent implements OnDestroy {
  @Input() userEmail!: string;
  userEmailParams!: string;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {
    this.route.queryParams.pipe(takeUntil(this._unsubscribe$)).subscribe((params) => {
      this.userEmailParams = params?.['email'];
    });
  }

  resendConfirmation(): void {
    const resendEmail = this.userEmail || this.userEmailParams;

    if (!resendEmail) {
      return;
    }

    this.authService.resendConfirmation(resendEmail).subscribe(() => {
      this.alertService.showAlert(this.translateService.instant('USER.ACTIVATION.INSTRUCTIONS'), 'success');
    });
  }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
